(function(){
"use strict";
var D=document, $=function(id){return D.getElementById(id)};
var DATA={}; try{ DATA=JSON.parse(($('sf-data')||{}).textContent||"{}") }catch(e){}
var FAMS=DATA.families||[], OFF=DATA.addon_discount||0.10, FREE=DATA.free_delivery_threshold||20000;

/* MONEY SCALE
   Shopify reports money in hundredths wherever it is generated server side:
   Liquid product.price and the cart.js payload both return 2500 for a 25 KD
   frame. The products.json feed returns "25.000", which the loaders turn
   into 25000. Everything here works on that x1000 scale. */
var money=function(c){return (c/1000).toFixed(3)+" KD"};
var sc=function(v){return (v||0)*10};

function tint(name,fallback){return (typeof window.SFTint==='function')?window.SFTint(name,fallback):(fallback||'#9bd1cc')}
function rangeOf(b){ return (typeof window.SFBundleRange==='function') ? window.SFBundleRange(b) : (b&&b.range)||'' }
var CATS=["Sunglasses","Optical","Blue Light","Kids","Limited drops"];
var SHAPES=["Square","Round","Cat-eye","Pilot","Rectangle","Oval","Hexagon"];
var MATERIALS=["Acetate","Metal","Titanium","Polycarbonate","Carbon fibre","Acetate and metal","Wood"];
var TECHS=["Full rim","Half rim","Rimless"];
var FCOL=[["Black","#1c1c1c"],["Brown","#6b4a30"],["Tortoise","#8a5a2b"],["Blue","#3a5a7d"],["Green","#4c6b4f"],
["Grey","#8b8f92"],["Silver","#c9ccce"],["Gold","#b39a63"],["Red","#9c3b32"],["Pink","#e59ab4"],["Yellow","#e3c74a"],["Clear","#dfe3e4"]];
var LCOL=[["Black","#1c1c1c"],["Brown","#6b4a30"],["Green","#3f5c46"],["Blue","#3a5a7d"],["Grey","#8b8f92"],
["Yellow","#e3c74a"],["Pink","#e59ab4"],["Red","#9c3b32"],["Clear","#eef1f2"]];
var TILES=["#f1f6fc","#e1d5ef","#f9e7d2","#fafe95","#f0f8f7","#fdeef2","#eef3ea","#f4f0e6"];
var SORTS=["Featured","Best selling","Price, low to high","Price, high to low"];
var TICK='<svg viewBox="0 0 24 24"><path d="m5 13 4 4L19 7"/></svg>';
function toast(t){var e=$('toast'); if(!e)return; e.textContent=t; e.classList.add('on');
clearTimeout(e._t); e._t=setTimeout(function(){e.classList.remove('on')},2400)}
function rgb(h){h=(h||'#888888').replace('#',''); if(h.length===3)h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
return [parseInt(h.slice(0,2),16),parseInt(h.slice(2,4),16),parseInt(h.slice(4,6),16)]}
function cd(a,b){var x=rgb(a),y=rgb(b);return Math.abs(x[0]-y[0])+Math.abs(x[1]-y[1])+Math.abs(x[2]-y[2])}
function famBy(h){for(var i=0;i<FAMS.length;i++)if(FAMS[i].handle===h)return FAMS[i];return null}
function closeAll(){['bag','filters','quick','menu'].forEach(function(i){var e=$(i);if(e)e.classList.remove('on')});
var s=$('scrim'); if(s)s.classList.remove('on')}
function open_(id){var s=$('scrim'); if(s)s.classList.add('on'); var e=$(id); if(e)e.classList.add('on')}
function openMenu(){open_('menu')}
function syncCount(n){[['cc',n],['tabCount',n]].forEach(function(p){var e=$(p[0]); if(!e)return;
e.textContent=p[1]; if(p[1])e.removeAttribute('hidden'); else e.setAttribute('hidden','')})}
function cartJSON(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()})}
function addItems(items){
return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
.then(function(r){return r.json()}).then(function(){return renderBag()})
}
function addVariant(id,qty,props){
var it={id:id,quantity:qty||1}; if(props)it.properties=props;
return addItems([it]).then(function(){openBag()})
}
function changeLine(key,qty){
return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json()}).then(function(){return renderBag()})
}
/* A bundle is several lines tied by _bundle_id. Removing one used to leave
   the others behind, still labelled as a bundle and waiting for a partner,
   so the shopper built another and kept the orphan too. Removing any line
   of a bundle removes the whole bundle. */
function removeBundle(gid){
return cartJSON().then(function(c){
var updates={};
(c.items||[]).forEach(function(l){
var g=l.properties && l.properties._bundle_id;
if(g && String(g)===String(gid)) updates[l.key]=0;
});
if(!Object.keys(updates).length) return null;
return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
body:JSON.stringify({updates:updates})}).then(function(r){return r.json()});
}).then(function(){ toast('Bundle removed'); return renderBag() });
}
function openBag(){renderBag(); open_('bag')}
function renderBag(){
var b=$('bagBody'), f=$('bagFoot'); if(!b)return Promise.resolve();
return cartJSON().then(function(c){
syncCount(c.item_count);
if(!c.item_count){
b.innerHTML='<div class="empty"><h3>Your bag is empty</h3><p>Pick a shape and the colours follow.</p>'+
'<a class="btn out sm" href="/collections">Shop frames</a></div>'; f.innerHTML=''; return}
var sizes={};
c.items.forEach(function(l){
var g=l.properties && l.properties._bundle_id;
if(g) sizes[g]=(sizes[g]||0)+1;
});
b.innerHTML=c.items.map(function(l,i){
var gid=l.properties && l.properties._bundle_id;
var whole=gid && sizes[gid]>1;
var tag=l.properties&&l.properties._bundle
? '<span style="font-size:10px;display:block;margin-top:2px" class="uc">'+
  (whole ? l.properties._bundle : 'Bundle incomplete &middot; priced on its own')+'</span>'
:(l.properties&&l.properties._set?'<span style="font-size:10px;display:block;margin-top:2px" class="uc">Set item &middot; 10% off</span>':'');
var qty=gid
? '<span style="display:block;font-size:11px;color:var(--mute);margin-top:6px">'+
  (whole?'Part of a bundle of '+sizes[gid]:'Was part of a bundle')+'</span>'
: '<div class="qty"><button onclick="SF.qty(\''+l.key+'\','+(l.quantity-1)+')">&minus;</button>'+
'<span class="mono">'+l.quantity+'</span>'+
'<button onclick="SF.qty(\''+l.key+'\','+(l.quantity+1)+')">+</button></div>';
var rm = gid
? '<button class="rm" onclick="SF.removeBundle(\''+gid+'\')">'+(whole?'Remove bundle':'Remove')+'</button>'
: '<button class="rm" onclick="SF.qty(\''+l.key+'\',0)">Remove</button>';
var was = (l.original_line_price && l.original_line_price > l.final_line_price)
? ' <s class="mono" style="color:#b3b8b7">'+money(sc(l.original_line_price))+'</s>' : '';
return '<div class="bagline"><img src="'+(l.image||'')+'" alt="">'+
'<div style="flex:1"><b>'+l.product_title+'</b>'+
'<span class="mono">'+money(sc(l.final_line_price))+was+'</span>'+tag+qty+'</div>'+
rm+'</div>'
}).join('');
var total=sc(c.total_price), free=total>=FREE;
b.innerHTML+='<div class="meter">'+(free?'Free delivery unlocked':money(FREE-total)+' more for free delivery')+
'<div class="b"><i style="width:'+(free?100:Math.min(100,total/FREE*100))+'%"></i></div></div>';
/* Subtotal is the price BEFORE discounts. items_subtotal_price is already
   net of them, which printed as "Subtotal 50, Discounts -10, Total 50". */
f.innerHTML='<div class="tot"><div><span>Subtotal</span><span class="mono">'+money(sc(c.original_total_price))+'</span></div>'+
(c.total_discount?'<div><span>Discounts</span><span class="mono">&minus;'+money(sc(c.total_discount))+'</span></div>':'')+
'<div><span>Delivery</span><span class="mono">'+(free?'Free':'calculated at checkout')+'</span></div>'+
'<div class="big"><span>Total</span><span class="mono">'+money(total)+'</span></div></div>'+
'<div style="margin-top:12px"><a class="btn" style="display:block" href="/checkout">Checkout</a></div>';
})
}
function paint(card,dot){
var img=card.querySelector('.sh img'); if(img&&dot.dataset.img)img.src=dot.dataset.img;
var link=card.querySelector('.sh a'); if(link&&dot.dataset.url)link.href=dot.dataset.url;
var meta=card.querySelector('a.meta'); if(meta&&dot.dataset.url)meta.href=dot.dataset.url;
var dots=dot.parentNode.querySelectorAll('i');
for(var i=0;i<dots.length;i++)dots[i].setAttribute('aria-pressed', dots[i]===dot?'true':'false');
}
function swap(handle,el){var card=$('c-'+handle); if(!card)return; paint(card,el)}
function reflow(dd){
var dots=dd.querySelectorAll('i');
for(var i=0;i<dots.length;i++)dots[i].style.display = i<6 ? '' : 'none';
}
function words(s){return String(s||'').toLowerCase().split(/[^a-z]+/).filter(Boolean)}
function bestDot(cands, wanted){
  if(!cands.length) return null;
  if(!wanted.length) return cands[0];
  var i,j;
  for(j=0;j<wanted.length;j++){
    var w=wanted[j].toLowerCase();
    for(i=0;i<cands.length;i++) if(String(cands[i].dataset.name||'').toLowerCase()===w) return cands[i];
  }
  for(j=0;j<wanted.length;j++){
    var w2=wanted[j].toLowerCase();
    for(i=0;i<cands.length;i++) if(words(cands[i].dataset.name).indexOf(w2)>-1) return cands[i];
  }
  return cands[0];
}
function previewColour(w){
var card=w.querySelector('.card'); if(!card)return;
var dd=card.querySelector('.dd'); if(!dd)return;
var dots=dd.querySelectorAll('i'); if(!dots.length)return;
if(!dd.dataset.order){
for(var n=0;n<dots.length;n++){dots[n].dataset.idx=n;} dd.dataset.order='1';
}
var target=null;
if(filt.fcolour.length||filt.lcolour.length){
var cands=[];
for(var i=0;i<dots.length;i++){
var fcs=(dots[i].dataset.colour||'').split('+'), lc=dots[i].dataset.lens||'';
var okF=!filt.fcolour.length;
for(var q=0;q<fcs.length && !okF;q++) if(filt.fcolour.indexOf(fcs[q].trim())>-1) okF=true;
var okL=!filt.lcolour.length||filt.lcolour.indexOf(lc)>-1;
if(okF&&okL) cands.push(dots[i]);
}
target=bestDot(cands, filt.fcolour.length?filt.fcolour:filt.lcolour);
}
var list=Array.prototype.slice.call(dots);
list.sort(function(a,b){return (+a.dataset.idx)-(+b.dataset.idx)});
if(target){var k=list.indexOf(target); list.splice(k,1); list.unshift(target)}
for(var j=0;j<list.length;j++)dd.insertBefore(list[j], dd.querySelector('.more')||null);
reflow(dd);
paint(card, target||list[0]);
}
function gridCols(grid){
  var t=getComputedStyle(grid).gridTemplateColumns;
  var n=(t||'').split(' ').filter(function(s){return s.trim()}).length;
  return n>0?n:1;
}
function shuffleTints(grid, visible){
  var cols=gridCols(grid), row=[], i, k;
  for(i=0;i<visible.length;i++){
    if(i % cols === 0) row=[];
    var sh=visible[i].querySelector('.sh');
    if(!sh) continue;
    if(sh.dataset.fixed){ row.push((sh.style.background||'').trim()); continue }
    var pool=TILES.filter(function(c){ return row.indexOf(c)<0 });
    if(!pool.length) pool=TILES.slice();
    k=pool[Math.floor(Math.random()*pool.length)];
    sh.style.background=k;
    row.push(k);
  }
}
function quick(handle){
var f=famBy(handle); if(!f){window.location='/collections/'+handle; return}
$('qTitle').textContent=f.title;
var sel=0;
$('qBody').innerHTML='<div class="swrow" id="qSw" style="margin-top:16px">'+f.products.map(function(p,i){
return '<button aria-pressed="'+(i===0)+'" data-i="'+i+'"><img src="'+p.img+'" alt=""><em>'+
p.title.replace(f.title,'').trim()+'</em></button>'}).join('')+'</div>'+
'<p class="pmeta" id="qn">'+f.products[0].title+' &middot; '+money(f.products[0].price)+'</p>';
var btns=$('qSw').querySelectorAll('button');
Array.prototype.forEach.call(btns,function(b){b.onclick=function(){
sel=+b.dataset.i;
Array.prototype.forEach.call(btns,function(x){x.setAttribute('aria-pressed','false')});
b.setAttribute('aria-pressed','true');
$('qn').textContent=f.products[sel].title+' \u00b7 '+money(f.products[sel].price);
$('qView').href=f.products[sel].url}});
$('qView').href=f.products[0].url;
$('qAdd').onclick=function(){addVariant(f.products[sel].id)};
open_('quick');
}
var filt={types:[],shape:[],fcolour:[],lcolour:[],mat:[],tech:[],min:0,max:10000};
var sortBy="Featured", sortOpen=false;
function nA(){return filt.types.length+filt.shape.length+filt.fcolour.length+filt.lcolour.length+
filt.mat.length+filt.tech.length+(filt.max<10000?1:0)+(filt.min>0?1:0)}
function wraps(){return Array.prototype.slice.call(D.querySelectorAll('#famGrid .fam-wrap'))}
function matches(w){
var d=w.dataset;
var isKid=(d.types||'').indexOf('Kids')>-1;
if(!filt.types.length&&isKid)return false;
if(filt.types.length&&!filt.types.some(function(t){return (d.types||'').indexOf(t)>-1}))return false;
if(filt.shape.length){
var mine=(d.shape||'').split('|'), hit=false;
for(var si=0;si<mine.length;si++){ if(filt.shape.indexOf(mine[si].trim())>-1){hit=true;break} }
if(!hit)return false;
}
if(filt.mat.length&&filt.mat.indexOf(d.material)<0)return false;
if(filt.tech.length&&!filt.tech.some(function(t){return (d.tech||'').indexOf(t)>-1}))return false;
if(filt.fcolour.length&&!filt.fcolour.some(function(c){return (d.fcolour||'').toLowerCase().indexOf(c.toLowerCase())>-1}))return false;
if(filt.lcolour.length&&!filt.lcolour.some(function(c){return (d.lens||'').toLowerCase().indexOf(c.toLowerCase())>-1}))return false;
if(+d.price>filt.max*1000)return false;
if(+d.price<filt.min*1000)return false;
return true}
function applySort(list){
var l=list.slice();
if(sortBy==="Price, low to high"){l.sort(function(a,b){return (+a.dataset.price)-(+b.dataset.price)}); return l}
if(sortBy==="Price, high to low"){l.sort(function(a,b){return (+b.dataset.price)-(+a.dataset.price)}); return l}
if(sortBy==="Best selling"){l.sort(function(a,b){return (+a.dataset.rank||9999)-(+b.dataset.rank||9999)}); return l}
l.sort(function(a,b){return (+a.dataset.order)-(+b.dataset.order)});
return l}
function renderShop(){
var grid=$('famGrid'); if(!grid)return;
var all=wraps(), shown=0, visible=[];
applySort(all).forEach(function(w){grid.appendChild(w);
var ok=matches(w); w.style.display=ok?'':'none'; if(ok){shown++; visible.push(w); previewColour(w)}});
shuffleTints(grid, visible);
var e=$('famEmpty'); if(e)e.style.display=shown?'none':'';
var c=$('famCount'); if(c)c.textContent=shown+(shown===1?' family':' families');
var fc=$('fCount'); if(fc)fc.textContent=nA()?' ('+nA()+')':'';
var sl=$('sortLbl'); if(sl)sl.textContent=sortBy;
var af=$('activeFilters');
if(af){var chips=[];
[['types','types'],['shape','shape'],['mat','mat'],['tech','tech']].forEach(function(k){
filt[k[0]].forEach(function(v){chips.push([k[0],v,v])})});
filt.fcolour.forEach(function(v){chips.push(['fcolour',v,v+' frame'])});
filt.lcolour.forEach(function(v){chips.push(['lcolour',v,v+' lens'])});
var extra=filt.min>0?'<button onclick="SF.setMin(0)">From '+filt.min+' KD <span style="opacity:.6">&#10005;</span></button>':'';
af.innerHTML=(chips.length||extra)?chips.map(function(c2){
return '<button onclick="SF.tog(\''+c2[0]+'\',\''+c2[1]+'\')">'+c2[2]+' <span style="opacity:.6">&#10005;</span></button>'}).join('')+extra+
'<button onclick="SF.clearFilters()" style="border-color:var(--line);color:var(--mute)">Clear all</button>':''}
var sm=$('sortmenu');
if(sm)sm.innerHTML=SORTS.map(function(v){return '<button role="option" aria-checked="'+(v===sortBy)+
'" onclick="SF.setSort(\''+v+'\')"><i>'+(v===sortBy?'&#10003;':'')+'</i>'+v+'</button>'}).join('');
}
function tog(k,v){var a=filt[k],i=a.indexOf(v); if(i>-1)a.splice(i,1); else a.push(v);
if($('filters')&&$('filters').classList.contains('on'))buildFilters(); renderShop()}
function setSort(v){sortBy=v; sortOpen=false; var m=$('sortmenu'); if(m)m.classList.remove('on'); renderShop()}
function toggleSort(){sortOpen=!sortOpen;var m=$('sortmenu');if(m){m.classList.toggle('on',sortOpen);
$('sortbtn').setAttribute('aria-expanded',String(sortOpen))}}
function chip(k,v,extra){return '<button class="chip" aria-pressed="'+(filt[k].indexOf(v)>-1)+
'" onclick="SF.tog(\''+k+'\',\''+v+'\')">'+(extra||'')+v+'</button>'}
function buildFilters(){
var b=$('fBody'); if(!b)return;
b.innerHTML=
'<div class="fgroup"><h4>Category</h4><div class="fopts">'+
CATS.map(function(v){return chip('types',v)}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Shape</h4><div class="fopts">'+
SHAPES.map(function(v){return chip('shape',v)}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Frame colour</h4><div class="cols">'+
FCOL.map(function(c){return '<button aria-pressed="'+(filt.fcolour.indexOf(c[0])>-1)+
'" onclick="SF.tog(\'fcolour\',\''+c[0]+'\')"><i style="background:'+c[1]+'"></i>'+c[0]+'</button>'}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Lens colour</h4><div class="cols">'+
LCOL.map(function(c){return '<button aria-pressed="'+(filt.lcolour.indexOf(c[0])>-1)+
'" onclick="SF.tog(\'lcolour\',\''+c[0]+'\')"><i style="background:'+c[1]+'"></i>'+c[0]+'</button>'}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Frame material</h4><div class="fopts">'+
MATERIALS.map(function(v){return chip('mat',v)}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Rim style</h4><div class="fopts">'+
TECHS.map(function(v){return chip('tech',v)}).join('')+'</div></div>'+
'<div class="fgroup"><h4>Price up to <span class="mono" id="pv">'+(filt.max>=10000?'any':filt.max+'.000 KD')+'</span></h4>'+
'<div class="range"><span class="mono" style="font-size:11px">0</span>'+
'<input type="range" min="0" max="100" step="5" value="'+(filt.max>100?100:filt.max)+'" oninput="SF.setMax(this.value)">'+
'<span class="mono" style="font-size:11px">100</span></div></div>';
}
function setMax(v){filt.max=(+v>=100)?10000:+v; var p=$('pv');
if(p)p.textContent=filt.max>=10000?'any':filt.max+'.000 KD'; renderShop()}
function setMin(v){filt.min=+v||0; renderShop()}
function openFilters(){buildFilters();open_('filters');renderShop()}
function applyFilters(){closeAll();renderShop()}
function clearFilters(){filt={types:[],shape:[],fcolour:[],lcolour:[],mat:[],tech:[],min:0,max:10000};
if($('filters'))buildFilters(); renderShop()}
function fromURL(){
var q; try{ q=new URLSearchParams(window.location.search) }catch(e){ return }
var map={type:'types',shape:'shape',fcolour:'fcolour',lcolour:'lcolour',material:'mat',tech:'tech'};
Object.keys(map).forEach(function(k){
var v=q.getAll(k);
if(v.length){ filt[map[k]]=[]; v.forEach(function(one){
one.split(',').forEach(function(part){ part=part.trim(); if(part)filt[map[k]].push(part) }) }) }
});
if(q.get('min'))filt.min=+q.get('min')||0;
if(q.get('max'))filt.max=+q.get('max')||10000;
if(q.get('sort'))sortBy=q.get('sort');
}
var setState={tab:0,picked:{},fam:null,variant:null,hex:'#888888',isKid:false};
function objectsFrom(handle){
return fetch('/collections/'+handle+'/products.json?limit=50').then(function(r){return r.json()})
.then(function(j){return (j.products||[]).filter(function(p){
return p.variants && p.variants[0] && p.variants[0].available !== false })
.map(function(p){
return {id:p.variants[0].id,name:p.title,price:Math.round(parseFloat(p.variants[0].price)*1000),
img:(p.images[0]||{}).src||'',hex:tint(p.title,'#8a8f8e')}})}).catch(function(){return []})
}
var CAPS=[],ACCS=[];
function rank(pool,hex){return pool.slice().sort(function(a,b){return cd(a.hex,hex)-cd(b.hex,hex)}).slice(0,3)}
function partners(){
var f=setState.fam; if(!f)return [];
var out=[];
FAMS.forEach(function(x){
if(x.handle===f.handle)return;
if(x.shape!==f.shape)return;
var xKid=(''+x.types).toLowerCase().indexOf('kids')>-1;
if(setState.isKid?xKid:!xKid)return;
var best=x.products.slice().sort(function(a,b){
return cd(a.hex||tint(a.title),setState.hex)-cd(b.hex||tint(b.title),setState.hex)})[0];
if(best)out.push({id:best.id,name:x.title+' \u00b7 '+best.title.replace(x.title,'').trim(),price:best.price,
img:best.img,hex:best.hex||tint(best.title),kind:xKid?'kidframe':'adultframe',
note:xKid?'Same '+(x.shape||'').toLowerCase()+', kid sized':'Same '+(x.shape||'').toLowerCase()+', adult size'})
});
return out.slice(0,2)
}
function setTotals(){
var base=setState.price||0, ex=0, save=0, n=0, kidMain=false;
Object.keys(setState.picked).forEach(function(k){var it=setState.picked[k]; ex+=it.price; n++;
if(it.kind!=='adultframe')save+=it.price*OFF;
if(setState.isKid&&it.kind==='adultframe')kidMain=true});
if(kidMain)save+=base*OFF;
return {raw:base+ex,net:base+ex-save,save:save,n:n}}
function renderSet(){
var host=$('setmod'); if(!host)return;
var t=setTotals();
var list = setState.tab===0 ? rank(ACCS,setState.hex).map(function(o){return {id:o.id,name:o.name,price:o.price,img:o.img,hex:o.hex,kind:'acc',note:'Picks up this colour'}})
: setState.tab===1 ? partners()
: rank(CAPS,setState.hex).map(function(o){return {id:o.id,name:o.name,price:o.price,img:o.img,hex:o.hex,kind:'cap',note:'Picks up this colour'}});
var rows = list.length ? list.map(function(it){
var on=!!setState.picked[it.id], disc=it.kind!=='adultframe';
var safeName=String(it.name).split("'").join("&#39;");
var col=it.hex||tint(it.name,setState.hex);
return '<button class="arow" data-on="'+(on?1:0)+'" aria-pressed="'+on+'"'+
' style="border-color:'+(on?'#141a19':col)+';border-width:1.5px"'+
' onclick="SF.pick('+it.id+','+it.price+
',\''+it.kind+'\',\''+safeName+'\',\''+it.img+'\')">'+
'<img src="'+it.img+'" alt="" style="box-shadow:inset 0 0 0 2px '+col+'">'+
'<span class="m"><b>'+it.name+'</b><span>'+
'<i style="display:inline-block;width:8px;height:8px;border-radius:50%;background:'+col+
';margin-right:6px;vertical-align:middle;box-shadow:inset 0 0 0 1px rgba(0,0,0,.15)"></i>'+it.note+'</span></span>'+
'<span class="mono" style="font-size:12px;text-align:right">'+
(disc?money(Math.round(it.price*(1-OFF)))+'<br><s style="color:var(--mute);font-size:10.5px">'+money(it.price)+'</s>':money(it.price))+
'</span><span class="tick">'+TICK+'</span></button>'}).join('')
: '<div class="none">Nothing to pair here yet. <u onclick="location.href=\'/collections\'">Browse everything</u>.</div>';
host.innerHTML='<h2 class="h-sec uc">Make it a set</h2>'+
'<div class="tabs" role="tablist">'+
'<button class="tab" role="tab" aria-selected="'+(setState.tab===0)+'" onclick="SF.setTab(0)">Accessories</button>'+
'<button class="tab" role="tab" aria-selected="'+(setState.tab===1)+'" onclick="SF.setTab(1)">'+(setState.isKid?'Grown-up match':'Mini match')+'</button>'+
'<button class="tab" role="tab" aria-selected="'+(setState.tab===2)+'" onclick="SF.setTab(2)">Caps</button></div>'+
'<div class="rows">'+rows+'</div>'+
'<div class="setfoot"><span class="t">'+(t.n?'Set of '+(t.n+1):'Frame only')+
'<b class="mono">'+money(Math.round(t.net))+(t.save?'<s>'+money(t.raw)+'</s>':'')+'</b></span>'+
'<button class="btn" style="width:auto;padding:14px 24px" onclick="SF.addSet()">'+(t.n?'Add set':'Add frame')+'</button></div>'+
'<p class="note">Ten percent comes off caps, accessories and kids frames. The frame you came for stays at '+money(setState.price)+'.</p>';
}
function setTab(i){setState.tab=i;renderSet()}
function pick(id,price,kind,name,img){
if(setState.picked[id])delete setState.picked[id];
else setState.picked[id]={price:price,kind:kind,name:name,img:img};
renderSet()}
function addSet(){
var items=[{id:setState.variant,quantity:1}];
var kidMain=setState.isKid&&Object.keys(setState.picked).some(function(k){return setState.picked[k].kind==='adultframe'});
if(kidMain)items[0].properties={_set:'yes'};
Object.keys(setState.picked).forEach(function(k){var it=setState.picked[k];
var i={id:+k,quantity:1};
if(it.kind!=='adultframe')i.properties={_set:'yes'};
items.push(i)});
addItems(items).then(function(){openBag();
var t=setTotals(); toast(t.save?'Set added':'Added to bag')})
}
function initPDP(){
var pdp=$('pdp'); if(!pdp)return;
var handle=pdp.dataset.family;
setState.fam=famBy(handle)||{title:'',products:[],shape:''};
setState.variant=+pdp.dataset.variant;
var mod=$('setmod');
var p=(setState.fam.products||[]).filter(function(x){return x.id===setState.variant})[0];
setState.price=p?p.price:0;
setState.hex=(p&&p.hex)||(p?tint(p.title,'#888888'):'#888888');
setState.isKid=(''+setState.fam.types).toLowerCase().indexOf('kids')>-1;
var capsH=(mod&&mod.dataset.caps)||'all-caps', accsH=(mod&&mod.dataset.accs)||'accessories';
Promise.all([objectsFrom(capsH),objectsFrom(accsH)]).then(function(r){CAPS=r[0];ACCS=r[1];renderSet()});
renderSet();
}
function gal(btn,src){var i=$('pimg'); if(i)i.src=src;
var sibs=btn.parentNode.querySelectorAll('button');
for(var k=0;k<sibs.length;k++)sibs[k].setAttribute('aria-pressed','false');
btn.setAttribute('aria-pressed','true')}

/* ---- Bundle builder ----
   ONLY ONE PAGE IS EVER RENDERED. The 25 KD range is 400+ frames; rendering
   all of them and hiding most made every pick rebuild four hundred cards,
   and while the browser was busy the next tap did nothing.

   EVERY IMAGE IS ON THE CARD. The builder keeps the shopper on one page, so
   a card is the only view of a frame they get. The images sit in a snapping
   strip: swipe on a phone, arrows on hover on a desktop. Tapping the strip
   still picks the frame; the arrows stop the event so browsing photos never
   adds something by accident. */
var POOL={}, tier=null, picks=[], busy=false;
var bundleShown=48;
function B(){return (DATA.bundles||{})[tier]}
function bundlePool(){var b=B(); return b?((POOL[b.collection]||[]).filter(function(p){return p.available})):[]}
function bundleView(){
  var pool=bundlePool();
  var fn = window.SF && window.SF.bundleView;
  return (typeof fn==='function') ? fn(pool) : pool;
}
function loadPool(handle){
if(POOL[handle]) return Promise.resolve(POOL[handle]);
if(typeof window.SFBundlePool!=='function'){POOL[handle]=[]; return Promise.resolve([])}
busy=true; renderBundles();
return window.SFBundlePool(handle).then(function(list){
POOL[handle]=list; busy=false; renderBundles(); return list});
}
function initBundles(){
if(!$('bGrid'))return;
if(!tier) tier=Object.keys(DATA.bundles||{})[0];
renderBundles();
var b=B(); if(b) loadPool(b.collection);
}
function setTier(t){var prev=B(); tier=t; var next=B();
if(!prev||!next||prev.collection!==next.collection)picks=[]; else picks=picks.slice(0,next.need);
bundleShown=48;
var reset = window.SF && window.SF.bundleReset;
if(typeof reset==='function') reset();
renderBundles();
if(next) loadPool(next.collection);
}
function togglePick(id){var b=B(), i=picks.indexOf(id);
if(i>-1)picks.splice(i,1); else {if(picks.length>=b.need)picks.shift(); picks.push(id)}
renderBundles()}
function showMoreBundles(){ bundleShown+=48; renderBundles() }
function slide(btn,dir,ev){
  if(typeof window.SFSlide==='function') return window.SFSlide(btn,dir,ev);
  if(ev && ev.stopPropagation) ev.stopPropagation();
  var strip=btn.parentNode.querySelector('.bstrip');
  if(strip) strip.scrollBy({left:dir*strip.clientWidth,behavior:'smooth'});
}
function bundleCard(p, on){
  var imgs = (p.imgs && p.imgs.length) ? p.imgs : (p.img ? [p.img] : []);
  var alt = String(p.title||'').split('"').join('');
  var strip = imgs.length
    ? '<div class="bstrip" onclick="SF.togglePick('+p.id+')">'+
        imgs.map(function(src,i){
          return '<img src="'+src+'" alt="'+alt+'" loading="'+(i?'lazy':'eager')+'">' }).join('')+
      '</div>'
    : '<div class="bstrip" onclick="SF.togglePick('+p.id+')"></div>';
  var nav = imgs.length>1
    ? '<button class="bnav p" aria-label="Previous image" onclick="SF.slide(this,-1,event)">&#8249;</button>'+
      '<button class="bnav n" aria-label="Next image" onclick="SF.slide(this,1,event)">&#8250;</button>'+
      '<span class="bcount">1 / '+imgs.length+'</span>'
    : '';
  return '<article class="card pickable" data-vid="'+p.id+'" data-picked="'+(on?1:0)+'">'+
    '<div class="sh bshell" style="background:var(--tile)">'+
      '<span class="pk">'+TICK+'</span>'+strip+nav+
    '</div>'+
    '<div class="meta"><span class="nm">'+p.title+'</span>'+
    '<span class="pr mono">'+money(p.price)+'</span></div></article>';
}
function renderBundles(){
var tabs=$('bTabs'); if(!tabs)return;
var bs=DATA.bundles||{};
tabs.innerHTML=Object.keys(bs).map(function(k){var b=bs[k];
return '<button class="btab" aria-pressed="'+(k===tier)+'" onclick="SF.setTier(\''+k+'\')">'+
'<b class="mono">'+b.label+'</b><span>Any '+b.need+' &middot; '+rangeOf(b)+
' frames &middot; normally '+money(b.was)+'</span></button>'}).join('');
var b=B(); if(!b)return;
var all=bundleView();
var page=all.slice(0, bundleShown);
var pool=bundlePool();
var chosen=picks.map(function(id){return pool.filter(function(p){return p.id===id})[0]}).filter(Boolean);
$('bLine').innerHTML='<span>Pick '+b.need+' from the '+rangeOf(b)+
' range &mdash; '+(busy?'loading frames':picks.length+' of '+b.need+' selected &middot; '+all.length+' to choose from')+
'</span>'+(picks.length?'<u onclick="SF.clearPicks()">Clear</u>':'');
$('bGrid').innerHTML = busy
? '<div class="empty" style="grid-column:1/-1"><h3>Loading the range</h3><p>Fetching every frame in this price range.</p></div>'
: (page.length?page.map(function(p){ return bundleCard(p, picks.indexOf(p.id)>-1) }).join('')
: '<div class="empty" style="grid-column:1/-1"><h3>Nothing in that mix</h3>'+
'<p>Drop a filter and the frames come back.</p></div>');
var more=$('bfMore');
if(more){
  var left=all.length-page.length;
  more.style.display = left>0 ? '' : 'none';
  more.textContent = 'Show '+Math.min(48,left)+' more';
}
var cEl=$('bfCount');
if(cEl) cEl.textContent = page.length<all.length ? page.length+' of '+all.length
  : all.length+(all.length===1?' frame':' frames');
var full=chosen.reduce(function(s,p){return s+p.price},0);
var ready=chosen.length===b.need;
$('bSel').innerHTML='<span class="picked">'+
Array.apply(null,{length:b.need}).map(function(_,i){
return chosen[i]?'<span><img src="'+chosen[i].img+'" alt=""></span>':'<span>'+(i+1)+'</span>'}).join('')+'</span>'+
'<span style="font-size:12.5px;color:var(--mute)">'+(ready
?'<b class="mono" style="color:var(--ink);font-size:15px">'+money(b.price)+'</b> <s class="mono">'+money(full)+
'</s><span style="display:block;font-size:11px">You save '+money(full-b.price)+'</span>'
:'Choose '+(b.need-chosen.length)+' more')+'</span>'+
'<button class="btn" style="width:auto;padding:13px 26px'+(ready?'':';opacity:.4;cursor:not-allowed')+
'" onclick="SF.addBundle()">Add bundle</button>';
if(window.SFBundleTint) window.SFBundleTint.refresh();
}
function clearPicks(){picks=[];renderBundles()}
function addBundle(){
var b=B(), pool=bundlePool();
var chosen=picks.map(function(id){return pool.filter(function(p){return p.id===id})[0]}).filter(Boolean);
if(chosen.length<b.need){toast('Pick '+(b.need-chosen.length)+' more'); return}
var gid=tier+'-'+Date.now();
var items=chosen.map(function(p){return {id:p.id,quantity:1,properties:{_bundle:b.label,_bundle_id:gid}}});
addItems(items).then(function(){picks=[];renderBundles();
toast(b.label+' added'); openBag()})
}
var deferred=null, forceMob=false;
window.addEventListener('beforeinstallprompt',function(e){e.preventDefault();deferred=e;
setTimeout(function(){var p=$('pwabar'); if(p)p.classList.add('on')},3000)});
function install(){var p=$('pwabar'); if(p)p.classList.remove('on');
if(deferred){deferred.prompt();deferred=null} else toast('On iPhone use Share, then Add to Home Screen')}
function syncMob(){D.body.classList.toggle('mob',forceMob||window.innerWidth<=900)}
var rt=null;
window.addEventListener('resize',function(){
syncMob();
clearTimeout(rt); rt=setTimeout(function(){
var grid=$('famGrid'); if(!grid)return;
shuffleTints(grid, wraps().filter(function(w){return w.style.display!=='none'}));
},250);
});
function toggleLang(){
var cur=(D.documentElement.lang||'en').slice(0,2);
window.location=(cur==='ar'?'/en':'/ar')+window.location.pathname}
D.addEventListener('click',function(){if(sortOpen)setSort(sortBy)});
function boot(){
syncMob();
syncCount(DATA.cart_count||0);
if($('famGrid')){fromURL();renderShop()}
if($('pdp'))initPDP();
if($('bGrid'))initBundles();
}
/* SF is published BEFORE boot runs: the bundle renderer reads it during its
   first render, and the inline handlers it writes need it immediately. */
window.SF={openBag:openBag,openMenu:openMenu,closeAll:closeAll,quick:quick,swap:swap,
addVariant:addVariant,qty:changeLine,removeBundle:removeBundle,renderBag:renderBag,
openFilters:openFilters,applyFilters:applyFilters,
clearFilters:clearFilters,tog:tog,setSort:setSort,toggleSort:toggleSort,setMax:setMax,setMin:setMin,
setTab:setTab,pick:pick,addSet:addSet,gal:gal,
setTier:setTier,togglePick:togglePick,clearPicks:clearPicks,addBundle:addBundle,
renderBundles:renderBundles,showMoreBundles:showMoreBundles,slide:slide,
install:install,toggleLang:toggleLang,toast:toast};

if(D.readyState!=='loading')boot(); else D.addEventListener('DOMContentLoaded',boot);
})();